import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { EnvironmentNameEnum } from '@environments/environment.enum';

@Injectable()
export class VersionCheckService {
  // this will be replaced by actual hash post-build.js
  private _currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';
  private _timeInterval;

  constructor(private _http: HttpClient) {}

  public stopVersionCheck(): void {
    if (this._timeInterval) clearInterval(this._timeInterval);
  }

  public initVersionCheck(): void {
    if (environment.name === EnvironmentNameEnum.DEV || environment.name === EnvironmentNameEnum.LOCAL) return;
    this.stopVersionCheck();
    // Each 5 minutes validate version
    const frequency = 1000 * 60 * 5;
    const url = environment.versionCheckURL;
    this._timeInterval = setInterval(() => this.checkVersion(url), frequency);
  }

  private checkVersion(url: string): void {
    // timestamp these requests to invalidate caches
    this._http.get(url + '?t=' + new Date().getTime()).subscribe({
      next: (response: any) => {
        const hash = response.hash;
        const hashChanged = this.hasHashChanged(this._currentHash, hash);

        if (environment.name === EnvironmentNameEnum.QA) {
          console.log('old hash version: ', this._currentHash); // eslint-disable-line no-console
          console.log('current hash version: ', hash); // eslint-disable-line no-console
          console.log('version change?: ', hashChanged); // eslint-disable-line no-console
        }

        if (hashChanged) this.reloadPage();
        this._currentHash = hash;
      },
      error: () => {},
    });
  }

  reloadPage() {
    let intervalTime = 3;
    const interval = setInterval(() => {
      if (intervalTime === 0) {
        console.log('reloading page'); // eslint-disable-line no-console
        location.reload();
        clearInterval(interval);
        return;
      }
      console.log(`Version changed. reloading page in: ${intervalTime}`); // eslint-disable-line no-console
      intervalTime--;
    }, 1000);
  }

  private hasHashChanged(currentHash: string, newHash: string): boolean {
    if (!currentHash || currentHash === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
      return false;
    }
    return currentHash !== newHash;
  }
}
